/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export class BrandingUiInfoKeys {
    public static APP_ICONS = {
        DEFAULT_BACKGROUND: 'defaultBackground',
        DEFAULT_EMPTY_STRIP: 'defaultEmptyStrip',
        LIVE_ICON: 'liveIcon',
        LIVE_ICON_SOURCE: 'liveSourceIcon',
        NAV_GUIDE_HIGHLIGHTED_ICON: 'navGuideHighlightedIcon',
        NAV_GUIDE_ICON: 'navGuideIcon',
        NAV_MY_SHOWS_HIGHLIGHTED_ICON: 'navMyShowsHighlightedIcon',
        NAV_MY_SHOWS_ICON: 'navMyShowsIcon',
        NAV_SETTINGS_HIGHLIGHTED_ICON: 'navSettingsHighlightedIcon',
        NAV_SETTINGS_ICON: 'navSettingsIcon',
        NEW_ICON: 'newIcon',
        PC_LOCKED_4x3: 'pcLocked4x3Image',
        PC_LOCKED_16x9: 'pcLocked16x9Image',
        PC_LOCKED_ICON: 'pcLockedIcon',
        PC_PIN_SPINNER: 'pcPinSpinner',
        PIN_CONTROL_ARROW_DOWN: 'pinControlArrowDownIcon',
        PIN_CONTROL_ARROW_UP: 'pinControlArrowUpIcon',
        SOURCE_SOCU_ICON: 'SOURCE_SOCU_ICON',
        SECONDARY_BRANDING: 'secondaryBranding',
        SCROLLING_PILL_LEFT_ARROW: 'scrollingPillLeftArrow',
        SCROLLING_PILL_RIGHT_ARROW: 'scrollingPillRightArrow',
        SCROLLING_PILL_GHOST_LEFT_ARROW: 'scrollingPillGhostLeftArrow',
        SCROLLING_PILL_GHOST_RIGHT_ARROW: 'scrollingPillGhostRightArrow',
        VIEW_ALL_LEFT_ARROW: 'viewAllLeftArrow',
    };

    public static APP_IMAGES = 'appImages';

    public static CATCH_UP = 'catchupName';

    public static CUSTOMER_SUPPORT_NAME = 'customerSupportName';

    public static DEVICE_NAME = 'deviceName';

    public static DEVICE_NAME_SHORT = 'deviceNameShort';

    public static DISPLAY_NAME = 'displayName';

    public static DISTRIBUTOR_NAME = 'distributorName';

    public static EPG_LOOK_BACK_HOURS = 'epgLookBackHours';

    public static IMAGE = 'image';

    public static MANUFACTURER_NAME = 'manufacturerName';

    public static PHONE_CUSTOMER_SUPPORT_NUMBER = 'phoneCustomerSupportNumber';

    public static START_OVER = 'startoverName';

    public static URL_CUSTOMER_SUPPORT = 'urlCustomerSupport';

    public static URL_ERROR = 'urlError';

    public static URL_PRIVACY = 'urlPrivacy';

    public static YOUR_CABLE_PROVIDER = 'yourCableProvider';
}
